import { Link } from "react-router-dom";
import { PRIVACY, TERMS } from "routes/CONSTANTS";
import Newsletters from "./ Newsletters";
import ContactInfo from "./ContactInfo";
import Sections from "./Sections";

const Footer = () => {
  return (
    <div className=" bg-green text-white py-12 gap-2 md:px-12 xl:px-28 px-5">
      <div className=" md:flex justify-between">
        <ContactInfo />
        <Sections />
        <Newsletters />
      </div>
      <div className="lg:flex items-center justify-between text-xs gap-4 text-gray pt-12 hidden ">
        <p className="justify-self-end">
          5900 Balcones Drive STE 100 Austin, TX 78731, United states.
        </p>
        <p>© {new Date().getFullYear()} Black Mental Health Matters. All rights reserved.</p>
        <div className="flex gap-8">
          <Link to={PRIVACY} className="justify-self-end hover:text-orange">
            Privacy Policy
          </Link>
          <Link to={TERMS} className="hover:text-orange">
            Term and Conditions
          </Link>
        </div>
        <a
          href="https://app.candid.org/profile/14928107/black-mental-health-matters-inc-87-2410591"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://widgets.guidestar.org/prod/v1/pdp/transparency-seal/14928107/svg"
            height={70}
            width={70}
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
